var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelmet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 6.71429C1.88889 6.71429 1 7 1 8.14286C1 9.28572 1.88889 9.57143 2.33333 9.57143H11.6667C12.1111 9.57143 13 9.28572 13 8.14286C13 7 12.1111 6.71429 11.6667 6.71429M2.33333 6.71429C2.44444 5.76191 2.73333 4.07143 3 3.5C3.46562 2.25281 4.58163 1.52826 5.66667 1.20468M2.33333 6.71429H3.66667M11.6667 6.71429C11.6667 5.88095 11.4983 4.30087 11 3.5C10.224 2.25281 9.26358 1.52826 8.27799 1.20468M11.6667 6.71429H10.3333M5.66667 1.20468C6.13517 1.06496 6.5979 1 7 1C7.42215 1 7.85242 1.06496 8.27799 1.20468M5.66667 1.20468V4.92857M8.27799 1.20468V4.92857",
    stroke: "#141414",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelmet);
export default __webpack_public_path__ + "static/media/helmet.853afc5b05e28ae2cae6477584296b75.svg";
export { ForwardRef as ReactComponent };